module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-4-cfbb8930d3d3c86841b50090cb32aa22.webp";